const LAUNCH_ATTEMPT_ID_CLAIM = 'launch_attempt_id'
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/**
 * Reads the launch id from the bootstrap JWT payload WITHOUT verifying the signature: the value
 * only joins a client event to the server's launch events, it never authorises anything. Returns
 * null for anything that is not a well-formed UUID claim; never throws.
 */
export const readLaunchAttemptIdClaim = (token: string): string | null => {
  try {
    const segments = token.split('.')
    if (segments.length < 3) return null
    const base64 = segments[1].replace(/-/g, '+').replace(/_/g, '/')
    const payload: unknown = JSON.parse(atob(base64.padEnd(Math.ceil(base64.length / 4) * 4, '=')))
    if (typeof payload !== 'object' || payload === null) return null
    const claim = (payload as Record<string, unknown>)[LAUNCH_ATTEMPT_ID_CLAIM]
    return typeof claim === 'string' && UUID_PATTERN.test(claim) ? claim : null
  } catch {
    return null
  }
}
